var _defs, _g, _g2, _g3, _rect, _g4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedpackIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 58.9033203125,
    height: 60.3740234375,
    viewBox: "0 0 58.9033203125 60.3740234375",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "master_svg0_7506_062907",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -22,
    y: -16,
    width: 55.84000015258789,
    height: 58.19200897216797
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    dx: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.10000000149011612 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svg1_7506_062909",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 15.84000015258789,
    height: 18.192001342773438
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.19200003147125244,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24000000953674316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9882352948188782 0 0 0 0 0.6705882549285889 0 0 0 0 0.3803921639919281 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    id: "master_svg2_422_014041",
    gradientTransform: "translate(36.42028088996062 26.28458670526743) rotate(88.20874661175759) scale(14.161530535216443 14.804272896972755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF4333",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF9A4B",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.036589328199625015,
    y1: 0.6229991316795349,
    x2: 0.9754989743232727,
    y2: 0.6229991316795349,
    id: "master_svg3_422_014032"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFB87B",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.92605948448181%",
    stopColor: "#FFEDDC",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F5C290",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svg4_7506_062911",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 15.84000015258789,
    height: 9.432000160217285
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.48000001907348633,
    dx: 0.48000001907348633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3840000629425049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.3843137323856354 0 0 0 0 0.1882352977991104 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.19200003147125244,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24000000953674316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9176470637321472 0 0 0 0 0.21176470816135406 0 0 0 0 0.10196078568696976 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow",
    result: "effect2_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: -0.04206855222582817,
    x2: 0.5,
    y2: 1,
    id: "master_svg5_422_014035"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F54027",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF3822",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svg6_7506_062910",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.7280000448226929,
    y: -1.7280000448226929,
    width: 18.528000593185425,
    height: 9.216000318527222
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.4320000112056732,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svg7_422_014027"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "4.285714402794838%",
    stopColor: "#FFBE92",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8252",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svg8_7506_062912",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.9200000762939453,
    y: -1.3440000414848328,
    width: 8.064000606536865,
    height: 9.05600357055664
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5760000348091125,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.48000001907348633
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9176470637321472 0 0 0 0 0.2078431397676468 0 0 0 0 0.10196078568696976 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svg9_7506_062918",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: 0,
    y: 0,
    width: 4.224000453948975,
    height: 4.224000453948975
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.19200003147125244,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24000000953674316
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9607843160629272 0 0 0 0 0.8823529481887817 0 0 0 0.6100000143051147 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    id: "master_svga_422_014022",
    gradientTransform: "translate(35.97761797904968 26.778813123703003) rotate(90) scale(2.1120002269744873 1.8021799383988792)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFD99E",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFC670",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svgb_7506_062913",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.440000057220459,
    y: -1.440000057220459,
    width: 5.424000263214111,
    height: 7.104000568389893
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.36000001430511475,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "master_svgc_7506_062914",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.9600000381469727,
    y: -0.9600000381469727,
    width: 4.920000076293945,
    height: 6.920000076293945
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0,
    dx: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.24000000953674316
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.9058823585510254 0 0 0 0 0.7215686440467834 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 36.229387283325195,
    y1: 24.882816314697266,
    x2: 36.229387283325195,
    y2: 29.882816314697266,
    gradientUnits: "userSpaceOnUse",
    id: "master_svgd_7506_059532"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF6A00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF3402",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9468770623207092,0.3215957581996918,-0.3215957581996918,0.9468770623207092,6.598348177562002,-8.179469014081405)",
    filter: "url(#master_svg0_7506_062907)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg1_7506_062909)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.0576171875,
    y: 15.8828125,
    width: 15.84000015258789,
    height: 18.192001342773438,
    rx: 1,
    fill: "url(#master_svg2_422_014041)",
    fillOpacity: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.0576171875,30.1628203125C28.0576171875,30.4809403125,28.3155011875,30.7388203125,28.6336171875,30.7388203125L43.321617187499996,30.7388203125C43.6397171875,30.7388203125,43.8976171875,30.4809403125,43.8976171875,30.1628203125L43.8976171875,24.0908203125Q39.8176171875,26.2508203125,35.8576171875,26.2508203125Q31.8976171875,26.2508203125,28.0576171875,24.0908203125L28.0576171875,30.1628203125Z",
    fill: "url(#master_svg3_422_014032)",
    fillOpacity: 1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg4_7506_062911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0576171875,33.114822265625C28.0576171875,33.645012265625,28.4874241875,34.074822265625,29.0176171875,34.074822265625L42.9376171875,34.074822265625C43.4678171875,34.074822265625,43.8976171875,33.645012265625,43.8976171875,33.114822265625L43.8976171875,24.642822265625Q39.6736171875,26.922822265625,35.7136171875,26.922822265625Q31.7536171875,26.922822265625,28.0576171875,24.642822265625L28.0576171875,33.114822265625Z",
    fill: "url(#master_svg5_422_014035)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.800000011920929
    },
    filter: "url(#master_svg6_7506_062910)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.441617280244827,
    y: 16.26678466796875,
    width: 15.072000503540039,
    height: 5.760000228881836,
    rx: 2,
    fill: "url(#master_svg7_422_014027)",
    fillOpacity: 1
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg8_7506_062912)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svg9_7506_062918)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.97761797904968,
    cy: 26.778813123703003,
    rx: 2.1120002269744873,
    ry: 2.1120002269744873,
    fill: "url(#master_svga_422_014022)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svgb_7506_062913)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.00161784887314,
    cy: 26.778813123703003,
    rx: 1.2720000743865967,
    ry: 2.1120002269744873,
    fill: "#FFF3DB",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#master_svgc_7506_062914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9115952833252,27.830396314697264L35.1037872833252,27.830396314697264L35.1037872833252,27.341186314697264L34.84420328332519,27.406076314697266L34.84420328332519,27.059136314697266L35.1037872833252,26.994236314697265L35.1037872833252,26.534976314697264L34.86916328332519,26.534976314697264L34.86916328332519,26.220476314697265L35.1037872833252,26.220476314697265L35.1037872833252,25.873536314697265L35.4282672833252,25.873536314697265L35.4282672833252,26.220476314697265L35.6279472833252,26.220476314697265L35.6279472833252,26.534976314697264L35.4282672833252,26.534976314697264L35.4282672833252,26.914366314697265L35.6529072833252,26.859456314697265L35.6529072833252,27.206396314697265L35.4282672833252,27.261316314697265L35.4282672833252,28.132416314697267L34.9115952833252,28.132416314697267L34.9115952833252,27.830396314697264ZM35.588011283325194,28.132416314697267Q35.685355283325194,27.842876314697264,35.717803283325196,27.626976314697266Q35.750247283325194,27.411076314697265,35.750247283325194,27.163966314697266L35.750247283325194,25.950916314697267Q36.047277283325194,25.948416314697266,36.3904772833252,25.933436314697264Q36.73367728332519,25.918466314697266,37.02320728332519,25.886016314697265L37.02320728332519,26.205506314697267Q36.586407283325194,26.250436314697264,36.074727283325196,26.265406314697266L36.074727283325196,26.589886314697267L37.1255472833252,26.589886314697267L37.1255472833252,26.909376314697266L36.836007283325195,26.909376314697266L36.836007283325195,27.303746314697264L37.0906072833252,27.368636314697266L37.0906072833252,27.658176314697265L36.836007283325195,27.593276314697267L36.836007283325195,28.132416314697267L36.5140272833252,28.132416314697267L36.5140272833252,27.508416314697264L36.221997283325194,27.433536314697264L36.221997283325194,27.143996314697265L36.5140272833252,27.218876314697265L36.5140272833252,26.909376314697266L36.074727283325196,26.909376314697266L36.074727283325196,27.163966314697266Q36.074727283325196,27.388606314697267,36.044777283325196,27.615746314697265Q36.0148272833252,27.842876314697264,35.939947283325196,28.132416314697267L35.588011283325194,28.132416314697267Z",
    fill: "url(#master_svgd_7506_059532)",
    fillOpacity: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedpackIcon);
export default __webpack_public_path__ + "media/RedpackIcon.cf1c75f4.svg";
export { ForwardRef as ReactComponent };